/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : AUTH : STYLES --------------- ++++++++++ */
export default theme => ({
    auth: {
    	padding: replacePXinStringWithEM(`150px 0`),
    	display: 'flex',
    	flexDirection: 'column',
    	alignItems: 'center',
    	'& header': {
    		'& .logo': {
    			width: pxToEm(150),
    			height: pxToEm(40)
    		},
    		marginBottom: pxToEm(30)
    	},
    	'& #body': {
			'& .group.name-main': {
				borderRadius: pxToEm(5),
				border: replacePXinStringWithEM(`1px solid #ECF0F7`),
				padding: replacePXinStringWithEM(`10px 15px 15px`),
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				'& .copy': {
					textAlign: 'center',
					maxWidth: pxToEm(355)
				},
				'& .form': {
					'& .griditem': {
						minWidth: pxToEm(404),
						'& .field': {
							minWidth: pxToEm(404)
						}
					},
					'& .ctas': {
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						'& .button': {
							width: '100%',
							maxWidth: `${pxToEm(404)} !important`
						}
					}
				},
				'& .link': {
					textDecoration: 'underline'
				}
			},
			'& .group.name-callout': {
				textAlign: 'center',
				marginTop: pxToEm(32)
			}
    	}
    },

    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: {
		auth: {
			'& #body': {
				width: '90%',
				margin: '0 auto',
				'& .group.name-main': {
					'& .form': {
						width: '100%',
						'& .grid': {
							'& .gridset': {
								width: '100%',
								'& .griditem': {
									minWidth: 'auto',
									width: '100%',
									marginRight: '0',
									'& .field': {
										minWidth: 'auto',
										width: '100%'
									}
								}
							}
						},
						'& .ctas': {
							'& .button': {
								maxWidth: `100% !important`
							}
						}
					}
				}
			}
		}
	}
});
